import { useEffect, useState } from 'react';

const SHORTCODE_STORAGE_KEY = 'selectedRadioShortcode';
const RADIO_ID_STORAGE_KEY = 'selectedRadioId';

function readStoredShortcode() {
  try {
    return localStorage.getItem(SHORTCODE_STORAGE_KEY) || '';
  } catch {
    return '';
  }
}

function readStoredRadioId() {
  try {
    return localStorage.getItem(RADIO_ID_STORAGE_KEY) || null;
  } catch {
    return null;
  }
}

export default function useSelectedRadio() {
  const [shortcode, setShortcode] = useState(() => readStoredShortcode());
  const [radioId, setRadioId] = useState(() => readStoredRadioId());
  const [name, setName] = useState("");

  useEffect(() => {
    const onRadioChange = (e) => {
      const detail = e?.detail || {};
      const r = e?.detail?.radio;
      if ('shortcode' in detail) setShortcode(detail.shortcode || '');
      const nextRadioId = detail.radioId ?? r?.id ?? null;
      setRadioId(nextRadioId == null ? null : String(nextRadioId));
      if (r?.name) setName(r.name);
      if (r === null) setName("");
    };
    window.addEventListener('radio:change', onRadioChange);
    return () => window.removeEventListener('radio:change', onRadioChange);
  }, []);

  useEffect(() => {
    const handleStorage = (event) => {
      if (event.key === SHORTCODE_STORAGE_KEY) {
        setShortcode(event.newValue || '');
      }
      if (event.key === RADIO_ID_STORAGE_KEY) {
        setRadioId(event.newValue || null);
      }
    };
    window.addEventListener('storage', handleStorage);
    return () => window.removeEventListener('storage', handleStorage);
  }, []);

  return { radioId, shortcode, name };
}
